var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74153 13.8473C10.3731 13.8473 13.317 10.9034 13.317 7.2718C13.317 3.64025 10.3731 0.696289 6.74153 0.696289C3.10997 0.696289 0.166016 3.64025 0.166016 7.2718C0.166016 10.9034 3.10997 13.8473 6.74153 13.8473Z",
    fill: "#EB001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2572 13.8471C17.8887 13.8471 20.8327 10.9031 20.8327 7.27156C20.8327 3.64 17.8887 0.696045 14.2572 0.696045C10.6256 0.696045 7.68164 3.64 7.68164 7.27156C7.68164 10.9031 10.6256 13.8471 14.2572 13.8471Z",
    fill: "#F79E1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3178 7.27134C13.3178 5.01688 12.1906 3.04422 10.4997 1.91699C8.80887 3.13816 7.68164 5.11081 7.68164 7.27134C7.68164 9.43186 8.80887 11.4985 10.4997 12.6257C12.1906 11.4985 13.3178 9.5258 13.3178 7.27134Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.6215a0d5a758309db823e95d15ba6f02.svg";
export { ForwardRef as ReactComponent };